export default __webpack_public_path__ + "d6fe416a676631826a98d13ef899049c.png";